<template>
  <div class="wrapper">
    <UiToastList />
    <div class="main k-login">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="kl-inr-1">
            <div class="kl-top">
              <h3>Sign In</h3>
              <!-- <ul>
                <li>
                  <router-link to="">
                    <img src="@/assets/img/k-google.png" />
                  </router-link>
                </li>
              </ul> -->
            </div>
            <form class="login-page-form" @submit.prevent="login">
              <!-- Username Field -->
              <div class="login-form-group login-username-group">
                <label for="login-username" class="login-label"
                  >UserName:</label
                >
                <input
                  type="text"
                  id="login-username"
                  class="login-input login-username-input"
                  v-model="usernameOrEmail"
                  placeholder="email"
                />
                <p class="field-error" v-if="fieldErrors.usernameOrEmail">
                  {{ fieldErrors.usernameOrEmail }}
                </p>
              </div>

              <!-- Password Field -->
              <div class="login-form-group login-password-group">
                <label for="login-password" class="login-label"
                  >Password:</label
                >
                <div class="login-password-wrapper">
                  <input
                    :type="isPasswordVisible ? 'text' : 'password'"
                    id="login-password"
                    class="login-input login-password-input"
                    v-model="password"
                    placeholder="Password"
                  />
                  <button
                    type="button"
                    class="password-toggle-button"
                    @click="togglePasswordVisibility"
                  >
                    <i
                      :class="
                        isPasswordVisible
                          ? 'fa-solid fa-eye-slash'
                          : 'fa-solid fa-eye'
                      "
                    ></i>
                  </button>
                </div>
                <p class="field-error" v-if="fieldErrors.password">
                  {{ fieldErrors.password }}
                </p>
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                class="login-submit-button login-primary-button"
                :disabled="isLoading"
              >
                Log in
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </button>

              <!-- Remember Me and Forgot Password -->
              <div class="login-options">
                <label class="remember-me-container">
                  <input
                    type="checkbox"
                    id="login-remember-me"
                    class="login-checkbox"
                  />
                  Remember me
                </label>
                <a href="#" class="forgot-password-link"
                  >Forget your password</a
                >
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-r-kl">
          <div class="kl-inr-2">
            <img
              src="@/assets/img/mamabots-logo.png"
              width="450"
              class="mb-5"
            />
            <h1>Welcome To MAMABOTS</h1>
            <p>Dont Have An Account?</p>
            <router-link to="/create-account">
              <button>Sign Up</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthService } from "@/services/auth.service";
import { handleError } from "@/services/util";
import UiToastList from "@/components/UiToastList";
import { lowercaseString } from "@/utils/helpers";

export default {
  name: "KioskLogin",
  components: {
    UiToastList,
  },
  data() {
    return {
      isPasswordVisible: false,
      usernameOrEmail: "",
      password: "",
      fieldErrors: {},
      isLoading: false,
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    async login() {
      // Reset errors
      this.fieldErrors = {};
      let isValid = true;

      // Validation
      if (!this.usernameOrEmail) {
        this.fieldErrors.usernameOrEmail = "Username is required.";
        isValid = false;
      }

      if (!this.password) {
        this.fieldErrors.password = "Password is required.";
        isValid = false;
      } else if (this.password.length < 6) {
        this.fieldErrors.password = "Password must be at least 6 characters.";
        isValid = false;
      }

      if (!isValid) return;

      this.isLoading = true;

      try {
        const response = await AuthService.makeLogin({
          email: lowercaseString(this.usernameOrEmail),
          password: this.password,
        });

        this.isLoading = false;

        if (response.success) {

          if (response.data?.otp === true) {
            localStorage.setItem("pendingLoginEmail", lowercaseString(this.usernameOrEmail));

            this.$store.commit("toast/NEW", {
              type: "success",
              message: "OTP sent. Please verify.",
            });

            this.$router.push({
              name: "KioskOtp",
              query: { email: lowercaseString(this.usernameOrEmail) },
            });

            return;
          }

          // 📌 IMPORTANT: OTP message comes directly from response.message
          const backendMessage = response.message;

          // 🔐 1. OTP DETECTED → redirect to OTP page
          if (backendMessage && backendMessage.toLowerCase().includes("otp")) {
            localStorage.setItem("pendingLoginEmail", lowercaseString(this.usernameOrEmail));

            this.$store.commit("toast/NEW", {
              type: "success",
              message: backendMessage,
            });

            this.$router.push({
              name: "KioskOtp",
              query: { email: lowercaseString(this.usernameOrEmail) },
            });

            return; // stop everything
          }

          // 🔒 2. NO OTP → Normal login (old behavior)
        if (!["kiosk", "hospital", "superadmin", "super_admin", "super-admin", "admin"].includes(response?.data?.user?.objectType)) {
            this.$store.commit("toast/NEW", {
              type: "error",
              message: "Provided email is not of type Kiosk, Hospital, Super Admin or Admin!",
            });
            return;
          }

          // Save token + hospital id
          localStorage.setItem("token", response?.data?.token);
          const hospitalId = response?.data?.hospitalId;
          localStorage.setItem("hospitalId", hospitalId);

          // Store user in Vuex
          this.$store.commit("user/SET_CURRENT_USER", response?.data);

          // this.$store.commit("toast/NEW", {
          //   type: "success",
          //   message: "Logged in successfully!",
          // });

          await new Promise((resolve) => setTimeout(resolve, 1000));
          
          const userRole = response?.data?.user?.objectType;
          if (["superadmin", "super_admin", "super-admin"].includes(userRole)) {
            await this.$router.push("/super-admin-selection");
          } else {
            await this.$router.push("/");
          }
          return;
        }

        // Error case
        this.$store.commit("toast/NEW", {
          type: "error",
          message: response.message,
        });
        return;
      } catch (error) {
        this.isLoading = false;
        handleError(error, this.fieldErrors, this.$store);
      }
    },
  },
};
</script>

<style scoped>
/* Hide browser's default password toggle */
input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

input[type="password"]::-webkit-credentials-auto-fill-button,
input[type="password"]::-webkit-caps-lock-indicator,
input[type="password"]::-webkit-strong-password-visibility-indicator,
input[type="password"]::-webkit-textfield-decoration-container button,
input[type="password"]::-webkit-inner-spin-button,
input[type="password"]::-webkit-outer-spin-button {
  display: none;
  -webkit-appearance: none;
  appearance: none;
}

/* For Firefox */
input[type="password"] {
  -moz-appearance: textfield;
}

/* Ensure the password wrapper has proper positioning */
.login-password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.login-password-input {
  width: 100%;
  padding-right: 40px; /* Make space for your custom icon */
}

.password-toggle-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  padding: 5px;
}

.password-toggle-button:focus {
  outline: none;
}

.password-toggle-button i {
  font-size: 1.2rem;
  color: #666;
}
</style>
